import Footer from "./layout/Footer";
import Head from "./form/Head";
// import { useState } from "react";

const FormIsian = () => {
    // const [inputData, setInputData] = useState({
    //     nama_depan: "",
    //     nama_belakang: "",
    //     alamat: "",
    //     kota: "",
    //     provinsi: "",
    //     handphone: "",
    //     handphone1: "",
    //     email: "",
    //     alamat_usaha: "",
    //     jenis_usaha: "",
    //     luas_tanah: "",
    //     luas_bangunan: "",
    //     status_lahan: "",
    //     referrer: "",
    //     contacts: [],
    //     terms: false,
    //   });


    return (
        <div className="overflow-hidden font-jasa">
            <Head />

            <div class="mt-10 sm:mt-0 wrapper mt-20">
                <div class="md:grid md:grid-cols-3 md:gap-6">

                    <div class="mt-5 md:mt-0 md:col-span-2 pt-20 mb-20">
                        <form action="#" method="POST">
                            <div class="md:col-span-1 text-center">
                                <div class="px-4 sm:px-0">
                                    <h3 class="text-center text-lg font-medium leading-6 text-gray-900">Mitra Space</h3>
                                    <p class="mt-1 text-sm text-gray-600">
                                        Formulir Pendaftaran
                                    </p>
                                </div>
                            </div>
                            <div class="shadow overflow-hidden sm:rounded-md">
                                <div class="px-4 py-5 bg-white sm:p-6">
                                    <div class="grid grid-cols-6 gap-6">
                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="first_name" class="block text-sm font-medium text-gray-700">Nama Depan</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Nama Depan" type="text" name="search" />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="last_name" class="block text-sm font-medium text-gray-700">Nama Belakang</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Nama Belakang" type="text" name="search" />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="email_address" class="block text-sm font-medium text-gray-700">Kota</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Kota" type="text" name="search" />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="country" class="block text-sm font-medium text-gray-700">Provinsi</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Provinsi" type="text" name="search" />
                                        
                                        </div>

                                        <div class="col-span-6">
                                            <label for="street_address" class="block text-sm font-medium text-gray-700">Alamat</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Alamat" type="text" name="search" />
                                        </div>

                                        <div class="col-span-6 sm:col-span-6 lg:col-span-2">
                                            <label for="city" class="block text-sm font-medium text-gray-700">HP 1</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="HP 1" type="text" name="search" />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label for="state" class="block text-sm font-medium text-gray-700">HP 2</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="HP 2" type="text" name="search" />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label for="postal_code" class="block text-sm font-medium text-gray-700">Email</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Email" type="text" name="search" />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label for="state" class="block text-sm font-medium text-gray-700">Jenis Usaha</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Jenis Usaha" type="text" name="search" />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label for="state" class="block text-sm font-medium text-gray-700">Luas Tanah</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Luas Tanah" type="text" name="search" />
                                        </div>
        
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label for="state" class="block text-sm font-medium text-gray-700">Luas Bangunan (m2)</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Jenis Usaha" type="text" name="search" />
                                        </div>

                                        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label for="state" class="block text-sm font-medium text-gray-700">Alamat Usaha</label>
                                            <input class=" border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="Alamat Usaha" type="text" name="search" />
                                        </div>
    
    
    <div class="col-span-6 sm:col-span-3">
                                            <label for="country" class="block text-sm font-medium text-gray-700">Status Tempat/Usaha</label>
                                            <select id="country" name="country" autocomplete="country" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                                <option>Milik Sendiri</option>
                                                <option>Sewa</option>
                                                
                                            </select>
                                        </div>
    
    
    <div class="col-span-6 sm:col-span-3">
                                            <label for="country" class="block text-sm font-medium text-gray-700">Mengetahui Trawlbens dari mana</label>
                                            <select id="country" name="country" autocomplete="country" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                                <option>Facebook</option>
                                                <option>Twitter</option>
                                                <option>Instagram</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                                <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                    <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default FormIsian;
